import type { DesktopBridge } from 'shared';
const bridges = new WeakMap<DesktopBridge, DesktopBridge>();

export function localModelUnavailableReason(deviceId?: string | null): string {
  if (!deviceId) return '';
  const desktop = getDesktopBridge();
  if (desktop?.deviceId === deviceId && !desktop.models)
    return '当前客户端不可用，请升级绑定电脑客户端后使用此模型';
  return desktop?.models && desktop.deviceId === deviceId
    ? ''
    : '当前设备不可用：此模型仅限绑定电脑使用，请切换到绑定电脑或选择其他模型';
}

/** 桌面端由受限 preload 注入；浏览器环境始终返回 undefined。 */
export function getDesktopBridge(): DesktopBridge | undefined {
  const source = (globalThis as typeof globalThis & { desktop?: DesktopBridge }).desktop;
  if (!source) return undefined;
  const cached = bridges.get(source);
  if (cached) return cached;
  let deviceId = source.deviceId;
  const session = <T extends { deviceId?: string } | null>(result: T): T => {
    if (result?.deviceId) deviceId = result.deviceId;
    return result;
  };
  const bridge = { ...source, get deviceId() { return deviceId; }, auth: { ...source.auth,
    login: async (...args: Parameters<DesktopBridge['auth']['login']>) => session(await source.auth.login(...args)),
    refresh: async () => session(await source.auth.refresh()),
  } };
  bridges.set(source, bridge);
  return bridge;
}
